module.exports = __webpack_public_path__ + "img/logo.0a0d3133.png";